

import React, { memo } from 'react';
import { Button } from '../../../ui-kit';
import HUBSPOT_LOGO from '../../../assets/images/hubspot-logo.svg';
import hubspotInstallRedirect from '../utils/hubspotInstallRedirect';








function HubSpotButton({
  disabled,
  authToken,
  hubspotLoading,
  onHubSpotDisconnectRequest
}) {
  const buttonProps = {
    disabled,
    type: 'TERTIARY',
    prefix: <img alt="hubspot" style={{ height: 36, marginTop: 5, marginLeft: -15, marginRight: -10 }} src={HUBSPOT_LOGO} />,
    onClick: () => {
      if (authToken && authToken.length > 0) {
        onHubSpotDisconnectRequest();
      } else {
        hubspotInstallRedirect();
      }
    }
  };

  return (
    hubspotLoading ?
    <Button disabled>Loading</Button> :
    <Button {...buttonProps}>{authToken ? 'Disconnect' : 'Connect'}</Button>);

}

export default memo(HubSpotButton);